import { render, staticRenderFns } from "./LeadListItem.vue?vue&type=template&id=4bef9d8a&scoped=true&"
import script from "./LeadListItem.vue?vue&type=script&lang=js&"
export * from "./LeadListItem.vue?vue&type=script&lang=js&"
import style0 from "./LeadListItem.vue?vue&type=style&index=0&id=4bef9d8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bef9d8a",
  null
  
)

export default component.exports